<template>
	<section class="view-layout-pwanotification" v-if="showPwaPrompt">
		<div class="content">
			<ChalkyBrandingBadge size="md" />

			<div>
				<h3>Install ChalkySticks</h3>
				<p>Improve your experience by installing the app to your device.</p>
			</div>
		</div>

		<div class="actions">
			<button class="button-secondary size-small" v-on:click="Handle_OnClickDismiss">Dismiss</button>
			<button class="button-primary size-small" v-on:click="Handle_OnClickInstall">Install</button>
		</div>
	</section>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @class ViewLayoutPwaNotification
	 * @package View/Layout
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewLayoutPwaNotification extends ViewBase {
		/**
		 * Whether to show the PWA install prompt
		 *
		 * @type boolean
		 */
		public showPwaPrompt: boolean = false;

		/**
		 * The deferred beforeinstallprompt event
		 *
		 * @type any
		 */
		protected deferredPrompt: any = null;

		/**
		 * @return void
		 */
		@mounted
		public attachEvents(): void {
			window.addEventListener('beforeinstallprompt', this.Handle_OnBeforeInstallPrompt);
		}

		/**
		 * @return void
		 */
		@beforeDestroy
		public detachEvents(): void {
			window.removeEventListener('beforeinstallprompt', this.Handle_OnBeforeInstallPrompt);
		}

		/**
		 * Handle beforeinstallprompt event
		 *
		 * @param Event e
		 * @return void
		 */
		protected Handle_OnBeforeInstallPrompt(e: Event): void {
			e.preventDefault();

			this.deferredPrompt = e;
			this.showPwaPrompt = true;
		}

		/**
		 * Trigger the PWA install prompt
		 *
		 * @return void
		 */
		public Handle_OnClickInstall(): void {
			if (this.deferredPrompt) {
				(this.deferredPrompt as any).prompt();
				(this.deferredPrompt as any).userChoice.then(() => {
					this.showPwaPrompt = false;
					this.deferredPrompt = null;
					this.$store.dispatch('settings/setPwaInstallStatus', 'accepted');
				});
			}
		}

		/**
		 * Dismiss the PWA notification
		 *
		 * @return void
		 */
		public Handle_OnClickDismiss(): void {
			this.showPwaPrompt = false;
			this.$store.dispatch('settings/setPwaInstallStatus', 'dismissed');
		}
	}
</script>

<style lang="scss">
	.view-layout-pwanotification {
		background-color: var(--chalky-blue-4);
		border: 1px solid var(--chalky-grey-3);
		border-radius: var(--rounded-corner);
		bottom: 2rem;
		box-shadow: 0 2px 16px rgba(0, 0, 0, 0.2);
		display: flex;
		flex-direction: column;
		gap: 2rem;
		justify-content: center;
		left: 1rem;
		max-width: 400px;
		padding: 1rem;
		position: fixed;
		width: calc(100% - 2rem);
		z-index: var(--z-overlay-bottom);

		.content {
			display: flex;
			flex-direction: row;
			gap: 1rem;
		}

		.actions {
			display: flex;
			flex-direction: row;
			gap: 1rem;

			button {
				flex: 1 1 auto;
			}
		}
	}
</style>
